export const SET_DATA = "magSensor.SET_DATA";
export const RESET_DATA = "magSensor.RESET_DATA";
